import React from 'react';
import { CircularProgress, Box, Typography } from "@mui/material";

interface Props {
    inverted?: boolean;
    content?: string;
}

export default function LoadingComponent({ inverted = true, content = 'Loading...' }: Props) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 120 }}>
            <CircularProgress color={inverted ? "inherit" : "primary"} />
            {content && (
                <Typography sx={{ mt: 2 }} color="text.secondary">
                    {content}
                </Typography>
            )}
        </Box>
    )
}